export { ClickOutsideDetect } from "./click-outside-detect.component";
